export const normalizeMainId = (value) =>
  String(value || "").trim().replace(/\s+/g, " ").toLowerCase();

export const normalizeExternalId = (value) =>
  String(value || "").trim().toUpperCase();

export function validateFundMappingRows(rows, context) {
  const populated = (rows || []).filter(
    (row) => row.fp_investment_fund_id || String(row.identifier_value || "").trim()
  );
  if (
    populated.some(
      (row) => !row.fp_investment_fund_id || !String(row.identifier_value || "").trim()
    )
  ) {
    return "Every mapping row must contain both a fund and an External ID.";
  }
  const normalized = populated.map((row) =>
    normalizeExternalId(row.identifier_value, context)
  );
  if (new Set(normalized).size !== normalized.length) {
    return "External IDs must be unique within the mapping table.";
  }
  return null;
}
